// extracted by mini-css-extract-plugin
export default {"container":"News_container__bmhj+","primaryTxt":"News_primaryTxt__Etvya","bold":"News_bold__4OdBg","duration":"News_duration__sdJgx","col":"News_col__BxiTh"};